import ApiService from './api';
import { safeArray } from '../utils/money';

export interface Notification {
  id: string;
  title: string;
  message: string;
  type: 'info' | 'success' | 'warning' | 'error';
  is_read: boolean;
  data?: Record<string, any>;
  created_at: string;
  read_at?: string;
}

export class NotificationService {
  /**
   * 获取通知列表
   */
  static async listNotifications(
    page: number = 1,
    limit: number = 20,
    filters?: { is_read?: boolean; type?: string }
  ): Promise<{
    data: Notification[];
    meta: any;
  }> {
    const params = { page, limit, ...filters };
    const response = await ApiService.get('/merchant/notifications', params);
    return {
      data: safeArray<Notification>(response.data),
      meta: response.meta || { total: 0, per_page: 20, current_page: 1, last_page: 1 },
    };
  }

  /**
   * 获取通知详情
   */
  static async getNotification(id: string): Promise<Notification> {
    const response = await ApiService.get<Notification>(`/merchant/notifications/${id}`);
    return response.data;
  }

  /**
   * 标记为已读
   */
  static async markAsRead(id: string): Promise<void> {
    await ApiService.put(`/merchant/notifications/${id}/read`);
  }

  /**
   * 标记所有为已读
   */
  static async markAllAsRead(): Promise<void> {
    await ApiService.put('/merchant/notifications/read-all');
  }

  /**
   * 获取未读数量
   */
  static async getUnreadCount(): Promise<number> {
    const response = await ApiService.get<{ count: number }>(
      '/merchant/notifications/unread-count'
    );
    return response.data.count;
  }

  // Note: Delete notification endpoint not available in backend
  // /**
  //  * 删除通知
  //  */
  // static async deleteNotification(id: string): Promise<void> {
  //   await ApiService.delete(`/merchant/notifications/${id}`);
  // }
}

export default NotificationService;
